import Iframe from './iframe'
import Image from './image'
import ImageMap from './image_map'
import Images from './images'
import Product from './product'
import StickMenu from './sticky_menu'
import Text from './text'
import Youtube from './youtube'

class BlockFactory {

  static get list() {
    return {
      'iframe': Iframe,
      'image': Image,
      'image_map': ImageMap,
      'images': Images,
      'product': Product,
      'sticky_menu': StickMenu,
      'text': Text,
      'youtube': Youtube
    }
  }

  static create(type, block) {
    const Klass = this.list[type]
    const instance = new Klass(block)
    return instance
  }

}

export default BlockFactory



// WEBPACK FOOTER //
// ./src/models/blocks/index.js